import PropTypes from "prop-types";

import { CityField } from "UI/FnrAddress";

import { useAutocompleteContext } from "./AutocompleteContext";
import ShadowField from "./ShadowField";

/**
 * City field auto-wired to the autocomplete context.
 */
export default function AutocompleteCityField({ disabled }) {
  // A stale value the candidate would replace is cleared by the hook's
  // clear-stash-restore effect, which empties this field so `shadows.city`
  // renders the candidate as a full ghost. Nothing extra to wire here.
  const { value, onChange, shadows, onFieldBlur, cityRef } =
    useAutocompleteContext();
  const typed = value.city || "";
  return (
    <ShadowField inputRef={cityRef} typed={typed} suffix={shadows.city}>
      <CityField
        ref={cityRef}
        disabled={disabled}
        value={typed}
        onChange={(e) => onChange({ city: e.target.value })}
        onBlur={() => onFieldBlur("city")}
        placeholder={shadows.city ? "" : undefined}
      />
    </ShadowField>
  );
}

AutocompleteCityField.propTypes = {
  disabled: PropTypes.bool,
};
